/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Credits_Amount_LabelInputs */

const en_admin_users_credits_amount_label = /** @type {(inputs: Admin_Users_Credits_Amount_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amount`)
};

const zh_admin_users_credits_amount_label = /** @type {(inputs: Admin_Users_Credits_Amount_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数量`)
};

/**
* | output |
* | --- |
* | "Amount" |
*
* @param {Admin_Users_Credits_Amount_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_users_credits_amount_label = /** @type {((inputs?: Admin_Users_Credits_Amount_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Credits_Amount_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_users_credits_amount_label(inputs)
	return zh_admin_users_credits_amount_label(inputs)
});
export { admin_users_credits_amount_label as "admin.users.credits_amount_label" }